import React, { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useLanguage } from "../i18n";
import { HeroSlider } from "./HeroSlider";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Hero = () => {
  const { t } = useLanguage();
  const [callUrl, setCallUrl] = useState("https://calendar.app.google/QGhqT7yoiUfFAr288");

  useEffect(() => {
    axios.get(`${API}/settings/public`).then((r) => r.data.calendly_url && setCallUrl(r.data.calendly_url)).catch(() => {});
  }, []);

  return (
    <section id="top" data-testid="hero-section" className="relative pt-16 pb-20 lg:pt-24 lg:pb-28 overflow-hidden">
      <div className="absolute -top-24 -right-24 w-[480px] h-[480px] rounded-full bg-amberl/15 blur-3xl pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12 lg:gap-8 items-center">
        <motion.div
          className="lg:col-span-12"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
        >
          <p data-testid="hero-overline" className="text-xs uppercase tracking-[0.25em] font-semibold text-amberdark mb-10 lg:mb-12">
            {t.hero.overline}
          </p>
          <h1 data-testid="hero-title" className="font-display text-5xl sm:text-6xl lg:text-7xl font-medium tracking-tighter leading-[0.98] text-ink">
            {t.hero.title}
          </h1>
          <p data-testid="hero-subtitle" className="mt-8 text-base sm:text-lg text-ink/85 font-medium leading-relaxed max-w-2xl">
            {t.hero.subtitle}
          </p>
          <div className="mt-10 px-2 sm:px-0 flex flex-col sm:flex-row sm:flex-wrap gap-4">
            <Link
              data-testid="hero-cta-primary"
              to="/richiedi-concept?plan=base"
              className="cta-glow group inline-flex items-center justify-center gap-3 bg-ink text-cream hover:bg-espresso rounded-sm px-8 h-12 text-xs font-semibold uppercase tracking-[0.15em]"
            >
              {t.hero.ctaPrimary}
              <span aria-hidden="true" className="text-sm leading-none transition-transform duration-300 group-hover:translate-x-1">&rarr;</span>
            </Link>
            <Link
              data-testid="hero-cta-secondary"
              to="/richiedi-concept?plan=advanced"
              className="inline-flex items-center justify-center border border-ink/20 text-ink hover:border-ink hover:bg-ink hover:text-cream transition-colors rounded-sm px-8 h-12 text-xs font-semibold uppercase tracking-[0.15em]"
            >
              {t.hero.ctaSecondary}
            </Link>
            <div className="flex flex-col items-stretch sm:items-start gap-1.5">
              <a
                data-testid="hero-cta-call"
                href={callUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center border border-amberdark/60 text-ink hover:border-ink hover:bg-ink hover:text-cream transition-colors rounded-sm px-8 h-12 text-xs font-semibold uppercase tracking-[0.15em]"
              >
                {t.escalation.cta}
              </a>
              <span data-testid="hero-cta-call-note" className="text-xs text-inksoft">{t.hero.ctaCallNote}</span>
            </div>
          </div>
        </motion.div>

        {/* <motion.div
          className="lg:col-span-6 lg:pl-8"
          initial={{ opacity: 0, y: 32 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2, ease: "easeOut" }}
        >
          <HeroSlider />
          <p data-testid="hero-founders" className="mt-4 text-xs uppercase tracking-[0.2em] text-inksoft text-right">
            {t.hero.founders}
          </p>
        </motion.div> */}
      </div>
    </section>
  );
};
